<div class="modal-footer justify-content-between">
    <p-button (click)="onCancelClick.emit()" [disabled]="cancelDisabled"  severity="secondary"  >
        {{ cancelLabel }}
    </p-button>
    <p-button [disabled]="saveDisabled" class="p-button-primary" type="submit">
        {{ saveLabel }}
    </p-button>
</div>
